import { useSelector } from 'react-redux';
import { useLoaderData, useLocation, useNavigate, useRouteLoaderData } from 'react-router';
import { paths } from '../../common/constants/pathVariables';
import { AnalyticsEventOrigins } from '../../common/utils/analyticsUtils';
import { deepEqual } from '../../common/utils/objectUtils';
import { HorizontalMobileBroadbandSubscriptions } from './HorizontalMobileBroadbandSubscriptions';
import { handleChangeOffer } from './OrderUtils';
import { getSubscription } from './SubscriptionUtils';
import type { OrderProps, SubscriptionCardWithModel } from './types';
import type { OrderMobileBBCommonLoaderData, SubscriptionUpdateLoaderData } from '../../common/loaders';
import type { State } from '../../selfservice/common/store';
import type { OfferProductMapType } from '../OrderSubscriptionSelection/OrderSubscriptionSelectionUtils';
import type { MobileBroadbandSubCardProps } from '../SubscriptionCard/SubscriptionCard';

export interface HorizontalMobileBroadbandNOESubscriptionsProps {
  subscriptionCards: MobileBroadbandSubCardProps[];
  isChangeOffer: true;
  offerAndFeeMap?: OfferProductMapType[];
}

export const HorizontalMobileBroadbandNOESubscriptions = ({
  subscriptionCards,
  isChangeOffer,
  offerAndFeeMap = [],
}: HorizontalMobileBroadbandNOESubscriptionsProps) => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const noeLoaderData = useRouteLoaderData('newMobileBBCommon') as OrderMobileBBCommonLoaderData | undefined;
  const changeOfferLoader = useLoaderData() as SubscriptionUpdateLoaderData | undefined;

  const { campaignsFromVoucher = [], campaignContextsFromVoucher = [] } = useSelector((reduxState: State) => {
    const campaigns = reduxState.campaigns;
    return {
      campaignsFromVoucher: campaigns?.campaigns,
      campaignContextsFromVoucher: campaigns?.campaignContexts,
      voucher: campaigns?.voucher,
    };
  }, deepEqual);

  const getCard = (cardName: string) => getSubscription(subscriptionCards as SubscriptionCardWithModel[], cardName);

  const onChangeOffer = ({ onlineModel, noeOfferCode, quantity, voucherCode, services }: OrderProps) => {
    const additionalOffers = [
      ...(noeLoaderData?.mobileBroadbandModel?.offers?.length ? noeLoaderData.mobileBroadbandModel.offers : []),
      ...(noeLoaderData?.elisaNettiModel?.offers?.length ? noeLoaderData.elisaNettiModel.offers : []),
    ];

    handleChangeOffer({
      onlineModel,
      navigate,
      search,
      quantity,
      voucherCode,
      services,
      offerAndFeeMap,
      campaignsFromVoucher,
      campaignContextsFromVoucher,
      noeOfferCode,
      additionalOffers,
      addOnRules: noeLoaderData?.addOnRules,
      subscription: changeOfferLoader?.subscription,
      confirmationPath: paths.PS_MOBILE_SUBSCRIPTION_UPDATE_CONFIRMATION,
    });
  };

  return (
    <HorizontalMobileBroadbandSubscriptions
      subscriptionCards={subscriptionCards}
      wide={true}
      getCard={getCard}
      onOrder={onChangeOffer}
      isChangeOffer={isChangeOffer}
      eventOrigin={AnalyticsEventOrigins.OMAELISA}
    />
  );
};
